import React from 'react';
import './ExperienceTimeline.css';

const milestones = [
  {
    period: '2011-2020',
    title: 'Mathematics & Research',
    description: 'Academic work in geometry, research seminars, and university teaching.',
  },
  {
    period: '2021-2023',
    title: 'Data & Cloud Engineer',
    description: 'Data products, cloud services, automation, ML and analytics platforms.',
  },
  {
    period: '2024',
    title: 'Generative AI Engineer',
    description: 'LLM applications, RAG systems, AI agents, and internal platform services.',
  },
  {
    period: '2025',
    title: 'AI Tech Lead',
    description: 'Agentic workflows, AI architecture, platform strategy, and team guidance.',
  },
  {
    period: '2026-Present',
    title: 'Staff AI Engineer',
    description: 'LLMs, agents, and production-grade AI software systems.',
  },
];

function ExperienceTimeline() {
  return (
    <section className="career-arc mb-10 rounded-lg border border-[var(--border-color)] bg-[var(--bg-card)] p-4 shadow-sm md:p-5">
      <div className="mb-5 text-left">
        <div>
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-[var(--accent-green)]">
            Career arc
          </p>
        </div>
      </div>

      <div className="career-arc__stage relative">
        <span className="career-arc__desktop-line" aria-hidden="true" />
        <ol className="career-arc__list relative grid grid-cols-1 gap-3 md:grid-cols-5">
          {milestones.map((milestone, index) => (
            <li
              key={milestone.period}
              className="career-arc__item relative"
              style={{ '--career-arc-index': index }}
            >
              <div className="career-arc__marker-wrap mb-2 flex flex-col items-center">
                <span className="career-arc__marker z-10 flex h-7 w-7 items-center justify-center rounded-full border-2 border-[var(--accent-gold)] bg-[var(--bg-primary)] shadow">
                  <span className="h-2.5 w-2.5 rounded-full bg-[var(--accent-gold-fill)]" />
                </span>
                <span className="mt-2 text-center text-sm font-semibold text-[var(--accent-gold)]">
                  {milestone.period}
                </span>
              </div>
              <article className="career-arc__card rounded-md border border-[var(--border-color)] bg-[var(--bg-primary)] p-3 text-left">
                <h3 className="text-sm font-bold leading-snug text-[var(--text-primary)]">
                  {milestone.title}
                </h3>
                <p className="mt-1.5 text-sm leading-snug text-[var(--text-secondary)]">
                  {milestone.description}
                </p>
              </article>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default ExperienceTimeline;
